var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.223,
    height: 49.652,
    viewBox: "0 0 48.223 49.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(-825.413 -5331.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(827 5355.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    transform: "translate(3.351 -2)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.238,
    cy: 5.238,
    r: 5.238,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.238,
    cy: 5.238,
    r: 3.738,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M-3559.337-1125.236h16.329s2.118-13.651-3.813-11.762l-.287.158-4.5,3.495-3.868-3.495s-1.309-1.186-3.3,1.339S-3559.337-1125.236-3559.337-1125.236Z",
    transform: "translate(3559.838 1148.372)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(854.928 5333.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    transform: "translate(3.361 -2)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.238,
    cy: 5.238,
    r: 5.238,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.238,
    cy: 5.238,
    r: 3.738,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M-3559.337-1125.236h16.329s2.118-13.651-3.813-11.762l-.287.158-4.5,3.495-3.868-3.495s-1.309-1.186-3.3,1.339S-3559.337-1125.236-3559.337-1125.236Z",
    transform: "translate(3559.838 1149.245)",
    fill: "none",
    stroke: "#383838",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(851.138 5365.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M-3403.25-985.066V-972.8h-13.223",
    transform: "translate(3416.473 987.044)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M-3407.813-979.415l5.315-6.006,5.02,6.006",
    transform: "translate(3415.782 985.421)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    transform: "translate(848.873 5347.405) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433-2",
    "data-name": "Path 433",
    d: "M13.223,0V12.263H0",
    transform: "translate(0 1.978)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434-2",
    "data-name": "Path 434",
    d: "M0,6.006,5.315,0l5.02,6.006",
    transform: "translate(7.969)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/Referrals.58cc35cba4782696ac8646a7636fc4e3.svg";
export { ForwardRef as ReactComponent };